var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangEnFlagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "English flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-language-dropdown",
    transform: "translate(-43.000000, -84.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(26.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tobias-Flag-of-the-United-Kingdom"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect124",
    fill: "#000066",
    x: 0,
    y: 0,
    width: 23.9765035,
    height: 14.9703593
  }), /*#__PURE__*/React.createElement("g", {
    id: "g584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.96065394e-14,0 L-2.96065394e-14,1.67373607 L21.2959304,14.9704092 L23.9765035,14.9704092 L23.9765035,13.296723 L2.68057309,0 L-2.96065394e-14,0 L-2.96065394e-14,0 Z M23.9765035,0 L23.9765035,1.67368617 L2.68057309,14.9703593 L-2.96065394e-14,14.9703593 L-2.96065394e-14,13.2966731 L21.2959304,0 L23.9765035,0 Z",
    id: "path146",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99020979,0 L9.99020979,14.9703593 L13.9862937,14.9703593 L13.9862937,0 L9.99020979,0 Z M0,4.99011976 L0,9.98023952 L23.9765035,9.98023952 L23.9765035,4.99011976 L0,4.99011976 Z",
    id: "path136",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.98814371 L0,8.98221557 L23.9765035,8.98221557 L23.9765035,5.98814371 L0,5.98814371 Z M10.7894266,0 L10.7894266,14.9703593 L13.1870769,14.9703593 L13.1870769,0 L10.7894266,0 Z",
    id: "path141",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.96651592e-16,14.9703593 L7.99216783,9.98023952 L9.77921656,9.98023952 L1.78704873,14.9703593 L-2.96651592e-16,14.9703593 Z M-2.96065394e-14,0 L7.99216783,4.99011976 L6.2051191,4.99011976 L-2.96065394e-14,1.11584068 L-2.96065394e-14,0 Z M14.1972869,4.99011976 L22.1894548,0 L23.9765035,0 L15.9843357,4.99011976 L14.1972869,4.99011976 Z M23.9765035,14.9703593 L15.9843357,9.98023952 L17.7713844,9.98023952 L23.9765035,13.8545685 L23.9765035,14.9703593 Z",
    id: "path150",
    fill: "#CC0000"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEnFlagIcon);
export default __webpack_public_path__ + "static/media/LangEnFlagIcon.8b1cf675c1f9407eac7cf57f29401896.svg";
export { ForwardRef as ReactComponent };